
import { onMounted, provide, ref, useContext, watch } from '@nuxtjs/composition-api';

export default {
  props: {
    slideOnMobile: {
      type: Boolean,
      default: true
    }
  },
  setup (props) {
    const { $vuetify } = useContext()
    const flip = ref(false)
    provide('flip', flip)

    const handlePageScroll = () => {
      if (!process.client || !props.slideOnMobile) { return; }
      if ($vuetify.breakpoint.smAndDown && flip.value) {
        document?.documentElement.classList.add('overflow-y-hidden')
        return
      }
      document?.documentElement.classList.remove('overflow-y-hidden')
    }

    const open = (reveal) => {
      flip.value = true
      reveal.value = true
      handlePageScroll()
    }

    const close = (reveal) => {
      flip.value = false
      reveal.value = false
      handlePageScroll()
    }

    onMounted(() => {
      watch($vuetify.breakpoint, handlePageScroll)
    })

    provide('flipper', {
      open, close, flip
    })

    return {
      close,
      open,
      flip
    }
  }
}
